import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ssnMask'
})
export class NumberMaskPipe implements PipeTransform {
  transform(ssnNumber: string): string {
    if (ssnNumber !== undefined && ssnNumber !== null && ssnNumber !== ''){
      try{
    const visibleDigits = 4;
    const maskedSection = ssnNumber.slice(0, -visibleDigits);
    const visibleSection = ssnNumber.slice(-visibleDigits);
    return maskedSection.replace(/./g, '*') + visibleSection;
      }catch(ex){
        console.log(ex + '-----' + ssnNumber);
    }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_pipe/ssnMasking.ts